var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelehealthRebrand = function SvgTelehealthRebrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2086B0",
    d: "M21.763 44H8.5V0h13.263l6.631 24.326-6.631 19.658z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005486",
    d: "M21.765 0h13.263v44H21.765z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.766 35.907h-10.89V2.373h10.89l5.452 18.542z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5ED",
    d: "M21.765 2.373h10.89v33.534h-10.89z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5CBBF3",
    d: "M21.762 41.5h-4.337v-3.08h4.337l2.169 1.713-2.169 1.383z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2086B0",
    d: "M21.765 38.405h4.337v3.08h-4.337z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M21.763 21.653h-1.226v5.579c0 1.178.472 2.263 1.226 3.048l.723-4.792z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M26.92 27.232a1.965 1.965 0 0 1-3.93 0v-5.579h-1.225v8.627a4.36 4.36 0 0 0 3.19 1.367 4.42 4.42 0 0 0 4.416-4.415v-1.603h-2.452z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#055498",
    d: "M17.41 15.603h-1.95V6.754h3.552v1.949h-1.618v6.898z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#003C63",
    d: "M28.045 15.603h-1.948v-6.9h-1.619V6.756h3.552v8.848zM19.453 9.254a1.524 1.524 0 1 0 0-3.048 1.524 1.524 0 0 0 0 3.048"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#003C63",
    d: "M24.075 9.254a1.524 1.524 0 1 0 0-3.048 1.524 1.524 0 0 0 0 3.048"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA870",
    d: "M21.764 22.958c-3.646 0-6.616-2.97-6.616-6.616v-2.027h2.593v2.027a4.03 4.03 0 0 0 4.023 4.023l1.115 1.21z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M25.788 16.342a4.03 4.03 0 0 1-4.023 4.023v2.593c3.646 0 6.616-2.97 6.616-6.616v-2.027h-2.593z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#003C63",
    d: "M28.049 27.327a2.656 2.656 0 1 0 0-5.312 2.656 2.656 0 0 0 0 5.312"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#003C63",
    d: "M28.048 26.007a1.336 1.336 0 1 0 0-2.672 1.336 1.336 0 0 0 0 2.671"
  })));
};
export default SvgTelehealthRebrand;